import { Alert, Box, Button, Container, FormControl, InputLabel, LinearProgress, MenuItem, Select, Skeleton, Snackbar, Stack, Table, TableBody, TableContainer, TableHead, TableRow, TextField, Typography } from '@mui/material'
import Paper from '@mui/material/Paper';
import TableCell, { tableCellClasses } from '@mui/material/TableCell';
import { styled } from '@mui/material/styles';
import { useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import AddIcon from '@mui/icons-material/Add';
import PrintIcon from '@mui/icons-material/Print';
import DeleteIcon from '@mui/icons-material/Delete';

import { ajout,getvendeurs,getcamions,showmodal,getList,remove } from "./bonCommandeSlice";
import axios from 'axios';
import Ajouter from './Ajouter';

export default function Boncommande() {

    const StyledTableCell = styled(TableCell)(({ theme }) => ({
        [`&.${tableCellClasses.head}`]: {
          backgroundColor: theme.palette.common.black,
          color: theme.palette.common.white,
        },
        [`&.${tableCellClasses.body}`]: {
          fontSize: 14,
        },
      }));
      
      const StyledTableRow = styled(TableRow)(({ theme }) => ({
        '&:nth-of-type(odd)': {
          backgroundColor: theme.palette.action.hover,
        },
        // hide last border
        '&:last-child td, &:last-child th': {
          border: 0,
        },
      }));

      
    const [Chargement, setChargement] = useState(false);
    const [Progession, setProgession] = useState(false);
    const [valVendeurs, setvalVendeurs] = useState('Tout');
    const [valCamions, setvalCamions] = useState('Tout');
    const [removeSuccess, setRemoveSuccess] = useState(false);

    const BonData = useSelector(state => state.boncommandesData);
    const ListVendeur = BonData.listVendeurs;
    const ListCamion = BonData.listCamions;
    const listBons=BonData.list;
    const ajoutSuccess = BonData.ajoutOk;

    const today = new Date();
    const year = today.getFullYear();
    const month = String(today.getMonth() + 1).padStart(2, '0');
    const day = String(today.getDate()).padStart(2, '0');
    const todayDate = `${year}-${month}-${day}`;
  
    const [selectedDate, setSelectedDate] = useState(todayDate);

    const dateField=useRef('')
  
    const handleDateChange = (event) => {
      setSelectedDate(event.target.value);
    };

    const handleVendeurChange = (event) => {
        setvalVendeurs(event.target.value);
      };
      const handleCamionChange = (event) => {
        setvalCamions(event.target.value);
      };

      const formatDateToFrench = (dateString) => {
        const [date] = dateString.split('T');
        const [year, month, day] = date.split('-');
        return `${day}/${month}/${year}`;
      };

      const navigate = useNavigate();
      const dispatch= useDispatch();

      const handleClose = (event, reason) => {
        if (reason === 'clickaway') {
          return;
        }
        dispatch(ajout(false));
        setRemoveSuccess(false);
      };

    const userData = useSelector(state => state.userData)
    const id = userData.id;
    const apitoken = userData.apitoken;
    const typeCompte = userData.type
    const apiUrl = process.env.REACT_APP_API_URL;

    const formatDate = (dateString) => {
        const [date] = dateString.split('T');
        const [year, month, day] = date.split('-');
        return `${year}-${month}-${day}`;
      };

      const suppression = async (idbon)=> {
        setProgession(true);

        try {
            const response = await axios.post(`${apiUrl}delete/boncommande/${id}/${apitoken}/${idbon}`);
            if(response.data.status==="ok")
                {
                    dispatch(remove(idbon));
                    setRemoveSuccess(true);
                    setProgession(false);
                }
        } catch (error) {
          navigate('/');
        }
    }
      const supprimer = (id,nom) => {
        let result = window.confirm(`Supprimer ce bon de sortie de ${nom} ?`);
        if (result === true) {
            suppression(id);
        }
      }

      const Imprimer = async (idbon,date,vendeur) =>{
        setProgession(true)
        try {
            const dateFr=formatDateToFrench(date)
            const response = await axios.get(`${apiUrl}generer/boncommande/${id}/${apitoken}/${idbon}`,{
              responseType: 'blob',
            });
            // Créez un lien pour télécharger le PDF
            const url = window.URL.createObjectURL(new Blob([response.data], {type: 'application/pdf'}));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download',`bon de sortie ${vendeur} du ${dateFr}.pdf`);
            document.body.appendChild(link);
            link.click();
        }
            catch (error) {
                console.error('Error generating fsortie:', error);
              }
    setProgession(false)
    }

    function ShowList() {
        if(listBons.length > 0){
          let listFiltre=listBons.filter(bon => formatDate(bon.date) === selectedDate)
        
          if(valVendeurs!=="Tout") {
            listFiltre = listFiltre.filter(bon => bon.vendeur["id"] === valVendeurs)
        }
        if(valCamions!=="Tout") {
          listFiltre = listFiltre.filter(bon => bon.camion["id"] === valCamions)
      }
          return listFiltre.map(Bons => {
            return(
              <StyledTableRow key={Bons._id}>
              <StyledTableCell component="th" scope="row">
                {Bons.vendeur.nom}
              </StyledTableCell>
              <StyledTableCell component="th" scope="row">
              {Bons.camion.designation}
              </StyledTableCell>
      
              <StyledTableCell component="th" scope="row">
              {Bons.date!=="" ? formatDateToFrench(Bons.date) : ''}
              </StyledTableCell>
              <StyledTableCell align="right">
              <Button sx={{ marginLeft: '10px',width:'140px' }} variant="outlined" color='primary' startIcon={<PrintIcon />} onClick={() => Imprimer(Bons._id,Bons.date,Bons.vendeur.nom)} >
              Imprimer
              </Button> 
              { typeCompte === "admin" ? 
              <Button sx={{ marginLeft: '10px',width:'140px' }} variant="outlined" color='error' startIcon={<DeleteIcon />} onClick={() => supprimer(Bons._id,Bons.vendeur.nom)}>
               Supprimer
              </Button>
                :
                ""
              }
              </StyledTableCell>
            </StyledTableRow>
            )
      
          })
          }
          else {
            return (
              <StyledTableRow>
              <StyledTableCell align='center' colSpan={7} component="th" scope="row">
              Pas de données
              </StyledTableCell>
            </StyledTableRow>
            )
          }
          }

    const getVendeurs=async () => {
        try {
        const response = await axios.post(`${apiUrl}vendeurs/${id}/${apitoken}`,
          {
            timeout: 20000,
          }
        );
        dispatch(getvendeurs(response.data));
        }
     catch (error) {
      navigate('/');    
    }
    }

    const getCamions=async () => {
        try {
        const response = await axios.post(`${apiUrl}camions/${id}/${apitoken}`,
          {
            timeout: 20000,
          }
        );
        dispatch(getcamions(response.data));
        }
      catch (error) {
      navigate('/');    
      }
      }

      const getBons=async () => {
        setChargement(true);
        try {
        const response = await axios.post(`${apiUrl}boncommande/${id}/${apitoken}`,
          {
            timeout: 20000,
          }
        );
        dispatch(getList(response.data));
        }
     catch (error) {
      navigate('/');    
    }
    setChargement(false);
    }

    useEffect(() =>{
        getBons();
        getVendeurs();
        getCamions();
        dispatch(showmodal(false));
        },[]);

  return (
    <Container maxWidth="lg" sx={{ marginTop: '40px' }}>
        
        <Typography variant="h4" align='center' color="primary">
        bon de sortie
        </Typography>
        <Box display="flex" width="100%" mt={5}>
        <Box>
{Chargement ? 
        <Skeleton sx={{ marginTop: '20px' }}  variant="rounded" height={56} width={150} />
         :
<FormControl sx={{ minWidth: 150 }}>
          <InputLabel id="demo-simple-select-label">Vendeurs</InputLabel>
          <Select
        
          labelId="demo-simple-select-label"
          id="demo-simple-select"
          value={valVendeurs}
          label="Vendeurs"
          onChange={handleVendeurChange}
        >
          <MenuItem value='Tout'>Tout</MenuItem>
          {ListVendeur.map((item) => (
         <MenuItem key={item._id} value={item._id}>
           {item.nom}
         </MenuItem>
       ))}
          </Select>
          </FormControl>
}
</Box>
<Box>
{Chargement ? 
        <Skeleton sx={{ marginTop: '20px',marginLeft:'20px' }}  variant="rounded" height={56} width={150} />
         :
<FormControl sx={{ minWidth: 150,marginLeft:2 }}>
          <InputLabel id="demo-simple-select-label">Camions</InputLabel>
          <Select
        
          labelId="demo-simple-select-label"
          id="demo-simple-select"
          value={valCamions}
          label="Camions"
          onChange={handleCamionChange}
        >
          <MenuItem value='Tout'>Tout</MenuItem>
          {ListCamion.map((item) => (
         <MenuItem key={item._id} value={item._id}>
           {item.designation}
         </MenuItem>
       ))}
          </Select>
          </FormControl>
}
</Box>

<Box>
{Chargement ? 
        <Skeleton sx={{ marginTop: '20px',marginLeft:'20px' }} variant="rounded" height={56} width={150} />
         :
         <TextField sx={{ marginLeft: 2 }}
         inputRef={dateField}
         value={selectedDate}
         onChange={handleDateChange}
         id="input-with-icon-textfield"
         label="Date chargement"
         size='normal'
         type='date'
     variant="outlined"
   />  
}
</Box>


            <Box style={{ marginLeft: 'auto' }}>

               {Chargement ? 
        <Skeleton sx={{ marginTop: '20px' }}  variant="rounded" height={56} width={241} />
         :

        <Button variant="contained" size='large' color="primary" startIcon={<AddIcon/>} onClick={() =>dispatch(showmodal(true))} >
    Nouveau bon de sortie
  </Button>  
} 
</Box>

            </Box>
        {Chargement ? 
        <Skeleton sx={{ marginTop: '20px' }}  variant="rounded" height={200} />
         :
         <>
        <TableContainer sx={{ marginTop: '20px' }} component={Paper}>
          
          { Progession ?
    <Box >
  <Stack sx={{ width: '100%', color: 'grey.500' }} spacing={2}>
        <LinearProgress color="success" />
      </Stack>
    </Box>
            :
            ''
            }
      <Table sx={{ minWidth: 700 }} aria-label="customized table">
        <TableHead>
          <TableRow>
            <StyledTableCell>Vendeur</StyledTableCell>
            <StyledTableCell>Camion</StyledTableCell>
            <StyledTableCell>Date</StyledTableCell>
            <StyledTableCell align="right">Actions</StyledTableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          <ShowList/>
        </TableBody>
      </Table>
    </TableContainer>
    <Snackbar open={ajoutSuccess} anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }} autoHideDuration={5000} onClose={handleClose}>
        <Alert
          onClose={handleClose}
          severity="success"
          variant="filled"
          sx={{ width: '100%' }}
        >
          bon de sortie ajouté avec succès
        </Alert>
      </Snackbar>

      <Snackbar open={removeSuccess} anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }} autoHideDuration={5000} onClose={handleClose}>
        <Alert
          onClose={handleClose}
          severity="success"
          variant="filled"
          sx={{ width: '100%' }}
        >
          bon de sortie supprimé avec succès
        </Alert>
      </Snackbar>
    </>
}
<Ajouter/>
    </Container>
  )
}
